module.exports = __webpack_public_path__ + "static/brandnewlittlelady-abcb86180230d1bb18b6ab839b230276.jpeg";